import { render } from "./Paginacion.vue?vue&type=template&id=088d7440"
import script from "./Paginacion.vue?vue&type=script&lang=js"
export * from "./Paginacion.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dracoghost/Documents/ProyectosFunkoPopMorelia/funkopopmorelia-catalogo-vue-v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__